import { Button, Flex, Image } from "@qws-org/ui-kit";
import type { FC } from "react";

import { getLinkPropsFromAction } from "~/core/utils/action.utils";
import type { SecondaryFooterProps } from "~/features/secondary-footer/SecondaryFooter";
import { useDirectus } from "~/shared/utils/directus/useDirectus";
import { getPictureData } from "~/shared/utils/get-picture-data";

export const BottomLogos: FC<SecondaryFooterProps> = ({
  data,
  isActionInactive,
  getUrl,
  onCallAction,
}) => {
  const { getDirectusImage } = useDirectus();
  return (
    <Flex
      align="center"
      justify={"center"}
      width={"100%"}
      d={{ p: { py: 20 } }}
      p={{ py: 16 }}
    >
      <Flex align="center" justify="center" flexWrap="wrap" gap={32}>
        {(data.bottom_logos ?? []).map((logo, i) => {
          const bottomLogo = getPictureData(
            logo?.secondary_layout_footer_logos_id?.logo,
          );
          const controlAction = logo?.secondary_layout_footer_logos_id?.action;
          const {
            isInactive,
            href,
            handlePress: handlePressButton,
          } = getLinkPropsFromAction({
            onCallAction,
            getUrl,
            controlAction,
            isActionInactive,
          });

          return (
            !isInactive && (
              <Flex key={i} align="center" justify="center">
                <Button
                  variant={"tertiary"}
                  p={{ py: 0, px: 0 }}
                  onPress={handlePressButton}
                  href={href}
                >
                  <Image
                    value={getDirectusImage(bottomLogo.id, {
                      width: bottomLogo.mWidth
                        ? bottomLogo.mWidth * 2
                        : undefined,
                      height: bottomLogo.mHeight
                        ? bottomLogo.mHeight * 2
                        : undefined,
                      format: "webp",
                      quality: 75,
                    })}
                    image={{
                      alt:
                        logo?.secondary_layout_footer_logos_id?.logo
                          ?.alternative_text ?? "",
                    }}
                    width={bottomLogo.mWidth}
                    height={bottomLogo.mHeight}
                    mdValue={getDirectusImage(bottomLogo.mdId, {
                      width: bottomLogo.mdWidth
                        ? bottomLogo.mdWidth * 2
                        : undefined,
                      height: bottomLogo.mdHeight
                        ? bottomLogo.mdHeight * 2
                        : undefined,
                      format: "webp",
                      quality: 75,
                    })}
                    dValue={getDirectusImage(bottomLogo.dId, {
                      width: bottomLogo.dWidth
                        ? bottomLogo.dWidth * 2
                        : undefined,
                      height: bottomLogo.dHeight
                        ? bottomLogo.dHeight * 2
                        : undefined,
                      format: "webp",
                      quality: 75,
                    })}
                    md={{
                      width: bottomLogo.mdWidth,
                      height: bottomLogo.mdHeight,
                    }}
                    d={{ width: bottomLogo.dWidth, height: bottomLogo.dHeight }}
                  />
                </Button>
              </Flex>
            )
          );
        })}
      </Flex>
    </Flex>
  );
};
